import { render, staticRenderFns } from "./albumDescription.vue?vue&type=template&id=77ca8243&scoped=true&lang=html&"
import script from "./albumDescription.vue?vue&type=script&lang=js&"
export * from "./albumDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ca8243",
  null
  
)

export default component.exports